export const formatDecimalNumber = (value: number | string | null | undefined) =>
  (value !== undefined && value !== null && value.toString().replace('.', ',')) || '';

export const formatDecimalNumber2Decimal = (value: number) =>
  new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value);

export const formatDecimalAndSeparateThousands = (value: number | string | null | undefined) =>
  formatDecimalNumber(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
